<template>
    <section class="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">

                    <div class="d-flex justify-content-center py-4">
                        <a href="index.html" class="logo d-flex align-items-center w-auto">
                            <img src="@/assets/images/wordmark2.svg" style="width: 140px;" />
                        </a>
                    </div><!-- End Logo -->

                    <div class="card mb-3">

                        <div class="card-body">

                            <div class="pt-4 pb-2">
                                <p v-if="invited" class="text-center small">Hey <strong>{{username}}</strong>, you've been invited to a project</p>
                                <p v-else class="text-center small">Enter your new password</p>
                            </div>

                            <form class="row g-3 needs-validation" novalidate>

                                <div class="col-12">
                                    <label for="yourPassword" class="form-label">Password</label>
                                    <input type="password" name="password" class="form-control" id="yourPassword" v-model="password"
                                        required>
                                    <div class="invalid-feedback">Please enter your password!</div>
                                </div>

                                <div class="col-12">
                                    <label for="yourPassword" class="form-label">Repeat password</label>
                                    <input type="password" name="repeatpassword" class="form-control" v-model="repeatPassword"
                                        id="repeatyourPassword" required>
                                    <div class="invalid-feedback">Please enter your password!</div>
                                </div>
                                <div v-if="good != ''" class="col-12 mt-3 text-success">
                                    {{ good }}
                                </div>
                                <div v-if="error != ''" class="col-12 mt-3 text-danger">
                                    {{ error }}
                                </div>
                                <div class="col-12 mt-5">
                                    <button class="btn btn-primary w-100" @click="reset" type="button"><span v-if="invited">Let's Go!</span><span v-else>Reset</span></button>
                                </div>

                            </form>
                            <div class="row" v-if="invited">
                                <div class="col-12">
                                   <p class="text-center small">Have an account? <a href="/login" >Log in</a></p> 
                                </div>
                            </div>

                        </div>
                    </div>



                </div>
            </div>
        </div>

    </section>
</template>
<script>
import { useRoute } from "vue-router";

export default {
    name: "resetpassword-page",
    data: function () {
        return {
            tk:"",
            password: "",
            repeatPassword: "",
            error: "",
            good: "",
            invited:false,
            username:""
        }
    },
    mounted() {
        let self = this;
        const route = useRoute()
        this.tk = route.params.id;
        this.$vtc.vtcFetch("/Auth/IsInvited?tk="+this.tk, null,'API2').then(function (data) {
            self.invited=data.invited;
            self.username=data.username;
        });
    },
    methods: {
        reset() {
            this.error="";
            this.good = "";
            let self = this;
            if (this.password != this.repeatPassword) {
                this.error = "The key don't match";
                return false;
            }
            
            this.$vtc.vtcFetch("/Auth/ResetPassword", { Token: this.tk, Password: this.password, RepeatPassword: this.repeatPassword },'API2').then(function (data) {
                console.log("RECIBO",data);
                if (data === true) {
                    self.good = "Success";
                    setTimeout(function () {
                        window.location.href = self.$vtc.getConfig().getHomeUrl();
                    }, 2000);

                }
                else if (data == 100) {
                    self.error = "The key doesn't match";
                }
                else if (data == 200) {
                    self.error = "Expired token";
                }
                else {
                    alert("Nothing to do");
                }
            });
        }
    }
}
</script>

<style></style>